import { reducerWithInitialState } from "typescript-fsa-reducers";
import {
  deleteSpread,
  loadBriefSpreads,
  reloadBriefSpreads,
  resetBriefSpread,
  updateActiveTab,
  updateFilter,
  updatePage,
  updateSearch,
  updateSort,
  updateStatusGroup
} from "./actions";

import {
  BriefSpreadResponse,
  SPREAD_COLUMNS,
  SpreadFilter,
  SpreadSort,
  SpreadStatusGroup
} from "./types";

export interface BriefSpreadState {
  spreadFilter: SpreadFilter;
  currentPage?: number;
  briefSpread: BriefSpreadResponse;
  spreadSort: SpreadSort;
  message?: string;
  searchTerm?: string;
  activeTab: number;
  statusGroup: SpreadStatusGroup;
}

export const defaultSpreadSort: SpreadSort = {
  sortColumn: SPREAD_COLUMNS.STATUS,
  sortAscending: false
};

export const defaultSpreadFilter: SpreadFilter = { active: true };
export const defaultSpreadStatusGroup: SpreadStatusGroup = { statusGroup: "" };
export const defaultBriefSpreadResponse: BriefSpreadResponse = {
  briefSpreadCount: 0,
  briefSpreadModels: { briefSpreadModels: [] }
};

const setBriefSpread = (
  state: Readonly<BriefSpreadState>,
  { result: { briefSpread } }: { result: { briefSpread: BriefSpreadResponse } }
): BriefSpreadState => ({
  ...state,
  briefSpread
});

const initialState: BriefSpreadState = {
  briefSpread: defaultBriefSpreadResponse,
  spreadSort: defaultSpreadSort,
  spreadFilter: defaultSpreadFilter,
  statusGroup: defaultSpreadStatusGroup,
  activeTab: 0
};

const briefSpreadReducer = reducerWithInitialState<Readonly<BriefSpreadState>>(
  initialState
)
  .case(deleteSpread.async.failed, (state, { error }) => ({
    ...state,
    message: error.message
  }))
  .case(loadBriefSpreads.async.done, setBriefSpread)
  .case(loadBriefSpreads.async.started, (state, _) => ({
    ...state
  }))
  .case(loadBriefSpreads.async.failed, (state, { error }) => ({
    ...state,
    message: error.message
  }))
  .case(reloadBriefSpreads.async.done, setBriefSpread)
  .case(resetBriefSpread, () => initialState)
  .case(updateSort, (state, sortColumn) => {
    const sortAscending =
      sortColumn === state.spreadSort.sortColumn
        ? !state.spreadSort.sortAscending
        : false;

    return {
      ...state,
      spreadSort: {
        sortColumn,
        sortAscending
      }
    };
  })
  .case(updatePage, (state, page) => {
    const currentPage =
      page.selected && page.selected === 0 ? undefined : page.selected;

    return { ...state, currentPage };
  })
  .case(updateSearch, (state, params) => {
    const searchTerm = params.query;
    return { ...state, searchTerm };
  })
  .case(updateFilter, (state, spreadFilter) => {
    return { ...state, spreadFilter };
  })
  .case(updateStatusGroup, (state, statusGroup) => {
    return { ...state, statusGroup };
  })
  .case(updateActiveTab, (state, params) => {
    const activeTab = params.activeTab;

    return { ...state, activeTab };
  });

export default briefSpreadReducer;



// WEBPACK FOOTER //
// ./src/documentList/reducer.ts